export default (data = {}) => ({
  value: '',
  currency_value: '',
  ledger_account: '',
  _is_pasted_by_user: false,
  _is_changed_by_user: false,
  is_manually_edited: false,
  ...data,
});
